import { CurrencySelect } from '@components'

import styled from '@emotion/styled'

export const AmountCurrencySelect = styled(CurrencySelect)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`

export const CurrencySelectLabel = styled.label`
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  position: absolute;
  white-space: nowrap;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
`
